module.exports = __webpack_public_path__ + "static/Feature-03-7616fd62384a124300e4098599e9a28f.png";